import Base64 from "@repo/utils/Base64";
import UObject from "@repo/utils/UObject";
import User from "./User.js";
import Organization from "./Organization.js";

type Staff = UObject.Override<
  UObject.RequiredBy<User, "name">,
  {
    id: Staff.Id;
    role: Staff.Role;
  }
>;

namespace Staff {
  export type Id = `sp_${string}`;

  export const roles = ["staff", "owner", "retired"] as const;
  export type Role = (typeof roles)[number];

  export namespace Params {
    export type Self = {
      pfpBase64: Base64;
    };
    export type Organization = Pick<Staff, "role">;
  }
  export type Invitation = {
    id: Invitation.Id;
    email: string;
    status: Invitation.Status;
    role: Exclude<Staff.Role, "retired">;
    organizationId: Organization.Id;
  };
  export namespace Invitation {
    export type Id = `oi_${string}`;
    export type Status = "pending" | "accepted" | "declined";
    export namespace Params {
      export type Self = { status: Exclude<Status, "pending"> };
      export type Organization = Pick<Invitation, "email" | "role">;
    }
  }
}

export default Staff;
